import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/Footer";

// const iframe = '<iframe ng-src="https://www.aensaecuador.org/catastro/" width="1250" height="800"></iframe>'

function MarketStudy() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <iframe
        src="https://app.powerbi.com/reportEmbed?reportId=9e5dddb4-4b78-4e05-9408-01d5bd1db1ce&autoAuth=true&ctid=b76a9200-d94c-4e4c-8d97-a30d49fbfd24"
        width="1250"
        height="800"
      ></iframe>
      <Footer />
    </DashboardLayout>
  );
}

export default MarketStudy;
